// extracted by mini-css-extract-plugin
export default {"root":"uulla","program":"t5i72","channel":"_2cOmM","feature":"_106ro","hiddenMobile":"sFZ1N","seeMoreImg":"_3bXuh"};